var kMVUDegToRad = 0.01745329252;

// Webkit messaging channels
var kWkModalManagerSetActive = 1;
var kWkInputFormSetActive = 2;
var wkTactiqsModalManagerChannel = null;
var wkTactiqsNmsMapManagerChannel = null;

function mvutils_conform360( val )
{
    while ( val > 360 ) val -= 360;
    while ( val < 0 ) val += 360;

    return val;
}

function mvutils_add360( val1, val2 )
{
    var result = val1 + val2;
    if ( result >= 360.0 ) result -= 360.0;

    return result;
}

function mvutils_substract360( val1, val2 )
{
    var result = 0.0;
    if ( val1 >= val2 )
    {
        if ( val1 > 270.0 && val2 < 90.0 )
        {
            result = -((360.0 - val1) + val2);
        }
        else
        {
            result = val1 - val2;
        }
    }
    else
    {
        if ( val1 <= 90.0 && val2 >= 270 )
        {
            result = val1 + (360.0 - val2);
        }
        else
        {
            result = val1 - val2;
        }
    }

    return result;
}

function mvutils_avg360_init( count )
{
    var data = { avg: 999999, count: count };

    return data;
}

function mvutils_avg360_reset( data, count )
{
    data.avg = 999999;
    data.count = count;
}

function mvutils_avg360_add( data, value )
{
    if ( isNaN(value) )
    {
        return data.avg;
    }

    if ( data.avg === 999999 )
    {
        data.avg = value;
        return value;
    }

    if ( (data.avg > 270 && data.avg <= 360)
         &&
         (value >= 0 && value < 90) )
    {
        value += 360;
    }
    if ( (data.avg >= 0 && data.avg < 90)
         &&
         (value > 270 && value <= 360) )
    {
        data.avg += 360;
    }

    data.avg = ((data.count - 1) * data.avg + value) / data.count;
    if ( data.avg >= 360 )
    {
        data.avg -= 360;
    }

    return data.avg;
}

function mvutils_calculate_xhdm( from, to )
{
    if ( from === undefined || to === undefined ) return 0;

    if ( (from.lat === 0 && from.lon === 0) || (to.lat === 0 && to.lon === 0) ) return 0;

    var p1 = from.lat * kMVUDegToRad;
    var p2 = to.lat * kMVUDegToRad;
    var dl = (to.lon-from.lon) * kMVUDegToRad;

    var y = Math.sin(dl) * Math.cos(p2);
    var x = Math.cos(p1)*Math.sin(p2) -
        Math.sin(p1)*Math.cos(p2)*Math.cos(dl);
    var brng = Math.atan2(y, x) / kMVUDegToRad;

    brng = (brng + 360) % 360;

    return brng;
}

function mvutils_distanceFromTo( fromLat, fromLon, toLat, toLon )
{
    var R = 6371; // Radius of the earth in km
    var dLat = mvutils_deg2rad(toLat-fromLat);  // deg2rad below
    var dLon = mvutils_deg2rad(toLon-fromLon);
    var a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(mvutils_deg2rad(fromLat)) * Math.cos(mvutils_deg2rad(toLat)) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
    ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    var d = R * c / 1.852; // Distance in nm

    return d;
}

function mvutils_intersectionPoint( from, to, point )
{
    var t = ((point.x-from.x) * (to.x-from.x) + (point.y-from.y) * (to.y-from.y))
            / (Math.pow((to.x-from.x), 2) + Math.pow((to.y-from.y), 2));

    var ix = from.x + t * (to.x-from.x);
    var iy = from.y + t * (to.y-from.y);

    return { x: ix, y: iy };
}

function mvutils_zoomForBounds( gmapBounds, gmapWidth, gmapHeight, maxZoom, allowFractionalZoom )
{
    var WORLD_DIM = { height: 256, width: 256 };

    function latRad( lat )
    {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom( mapPx, worldPx, fraction)
    {
        if ( allowFractionalZoom )
        {
            return Math.log(mapPx / worldPx / fraction) / Math.LN2 - 0.5;
        }
        else
        {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2 - 0.5);
        }
    }

    var ne = gmapBounds.getNorthEast();
    var sw = gmapBounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    var latZoom = zoom( gmapHeight, WORLD_DIM.height, latFraction );
    var lngZoom = zoom( gmapWidth, WORLD_DIM.width, lngFraction );

    return Math.min( latZoom, lngZoom, maxZoom );
}

function mvutils_padNum( num, size )
{
    num = num.toString();
    while (num.length < size) num = '0' + num;
    return num;
}

function mvutils_deg2rad( deg )
{
    return deg * (Math.PI/180)
}

function mvutils_getDistInfo( data, from, to, prop )
{
    if ( !Array.isArray( data ) )
    {
        return { avg: 0, stdDev: 0 };
    }

    var len = to - from;
    var avg = 0;
    for ( var i=from; i<to; i++ )
    {
        avg += data[i][prop];
    }
    avg /= len;

    stdDev = 0;
    for ( i=from; i<to; i++ )
    {
        stdDev += ((data[i][prop] - avg) * (data[i][prop] - avg));
    }
    stdDev = Math.sqrt( stdDev );

    return { avg: avg, stdDev: stdDev };
}

// Color manipulation functions
function mvutils_changeHue(rgb, degree) {
    var hsl = mvutils_rgbToHSL(rgb);
    hsl.h += degree;
    if (hsl.h > 360) {
        hsl.h -= 360;
    }
    else if (hsl.h < 0) {
        hsl.h += 360;
    }
    return mvutils_hslToRGB(hsl);
}

function mvutils_rgbToHSL( rgb )
{
    // strip the leading # if it's there
    rgb = rgb.replace(/^\s*#|\s*$/g, '');

    // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
    if(rgb.length == 3){
        rgb = rgb.replace(/(.)/g, '$1$1');
    }

    var r = parseInt(rgb.substr(0, 2), 16) / 255,
        g = parseInt(rgb.substr(2, 2), 16) / 255,
        b = parseInt(rgb.substr(4, 2), 16) / 255,
        cMax = Math.max(r, g, b),
        cMin = Math.min(r, g, b),
        delta = cMax - cMin,
        l = (cMax + cMin) / 2,
        h = 0,
        s = 0;

    if (delta == 0) {
        h = 0;
    }
    else if (cMax == r) {
        h = 60 * (((g - b) / delta) % 6);
    }
    else if (cMax == g) {
        h = 60 * (((b - r) / delta) + 2);
    }
    else {
        h = 60 * (((r - g) / delta) + 4);
    }

    if (delta == 0) {
        s = 0;
    }
    else {
        s = (delta/(1-Math.abs(2*l - 1)))
    }

    return {
        h: h,
        s: s,
        l: l
    }
}

function mvutils_hslToRGB(hsl) {
    var h = hsl.h,
        s = hsl.s,
        l = hsl.l,
        c = (1 - Math.abs(2*l - 1)) * s,
        x = c * ( 1 - Math.abs((h / 60 ) % 2 - 1 )),
        m = l - c/ 2,
        r, g, b;

    if (h < 60) {
        r = c;
        g = x;
        b = 0;
    }
    else if (h < 120) {
        r = x;
        g = c;
        b = 0;
    }
    else if (h < 180) {
        r = 0;
        g = c;
        b = x;
    }
    else if (h < 240) {
        r = 0;
        g = x;
        b = c;
    }
    else if (h < 300) {
        r = x;
        g = 0;
        b = c;
    }
    else {
        r = c;
        g = 0;
        b = x;
    }

    r = _mvutils_normalize_rgb_value(r, m);
    g = _mvutils_normalize_rgb_value(g, m);
    b = _mvutils_normalize_rgb_value(b, m);

    return mvutils_rgbToHex(r,g,b);
}

function mvutils_rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

function mvutils_hslToHex(h, s, l)
{
    h /= 360;
    s /= 100;
    l /= 100;
    var r, g, b;

    if (s === 0)
    {
        r = g = b = l; // achromatic
    }
    else
    {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = _mvutils_hue2rgb(p, q, h + 1 / 3);
        g = _mvutils_hue2rgb(p, q, h);
        b = _mvutils_hue2rgb(p, q, h - 1 / 3);
    }

    return '#' + _mvutils_toHex( r ) + _mvutils_toHex( g ) + _mvutils_toHex( b );
}

// Safely check if browser local storage is available (can be disabled in privacy settings)
function mvutils_browserLocalStorageAvailable()
{
    var storage;
    try {
        storage = window['localStorage'];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
                     // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
               // acknowledge QuotaExceededError only if there's something already stored
               (storage && storage.length !== 0);
    }
}

function mvutils_create_sailcast_name( name )
{
    // First sanitize the input string
    name = name.toUpperCase();
    name = name.replace(/[^A-Z0-9 -]/g,'');

    var comps = name.split(' ');
    var stag = '';

    if ( comps.length === 3 && comps[0].length > 0 && comps[1].length > 0 && comps[2].length > 0 )
    {
        stag += comps[0].charAt(0) + comps[1].charAt(0) + comps[2].charAt(0);
    }
    else if ( comps.length === 2
              &&
              ((comps[0].length > 0 && comps[1].length > 1) || (comps[0].length > 1 && comps[1].length > 0)) )
    {
        if ( comps[1].length > comps[0].length )
        {
            stag += comps[0].charAt(0) + comps[1].charAt(0) + comps[1].charAt(1);
        }
        else
        {
            stag += comps[0].charAt(0) + comps[0].charAt(1) + comps[1].charAt(0);
        }
    }
    else
    {
        stag = name.substr( 0, Math.min( 3, name.length ) );
    }

    return stag;
}

// Private helper functions
function _mvutils_hue2rgb( p, q, t )
{
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;

    return p;
}

function _mvutils_toHex( x )
{
    var hex = Math.round(x * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}

function _mvutils_normalize_rgb_value(color, m) {
    color = Math.floor((color + m) * 255);
    if (color < 0) {
        color = 0;
    }
    return color;
}

/// Webkit messaging channels

function _mvutils_init_wk_channels()
{
    // Channel to manage modal states
    if ( typeof window.webkit !== 'undefined'
         && typeof window.webkit.messageHandlers !== 'undefined'
         && typeof window.webkit.messageHandlers.wkTactiqsModalManager !== 'undefined' )
    {
        wkTactiqsModalManagerChannel = window.webkit.messageHandlers.wkTactiqsModalManager;
    }

    // Channel to manage the NMS map overlay
    if ( typeof window.webkit !== 'undefined'
         && typeof window.webkit.messageHandlers !== 'undefined'
         && typeof window.webkit.messageHandlers.wkTactiqsNmsMapManager !== 'undefined' )
    {
        wkTactiqsNmsMapManagerChannel = window.webkit.messageHandlers.wkTactiqsNmsMapManager;
    }
}

function _mvutils_send_webkit_msg( channel, msg )
{
    if ( channel === 'wkTactiqsNmsMapManager' )
    {
        if ( wkTactiqsNmsMapManagerChannel !== null )
        {
            wkTactiqsNmsMapManagerChannel.postMessage(msg);
        }
    }
    else if ( channel === 'wkTactiqsModalManager' )
    {
        if ( wkTactiqsModalManagerChannel !== null )
        {
            console.log('Sending msg: ' + msg);
            wkTactiqsModalManagerChannel.postMessage(msg);
        }
        else
        {
            console.log('Channel not set for sending msg ' + msg)
        }
    }

}

// Always initialize webkit messaging channels
_mvutils_init_wk_channels();
